import React, {useState} from "react";
import OptimizedSlider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Modal1 from '../Modal/modal1';
import Modal2 from '../Modal/modal2';
import Modal3 from '../Modal/modal3';
import Modal4 from '../Modal/modal4';
import Modal5 from '../Modal/modal5';
import Modal6 from '../Modal/modal6';

import img1 from '../../assets/logos/img1.png';
import img2 from '../../assets/logos/img2.png';
import img3 from '../../assets/logos/img3.png';
import img4 from '../../assets/logos/img5.png';
import img5 from '../../assets/logos/img4.png';
import img6 from '../../assets/logos/img6.png';

import "./ServicesCarousel.css";

const items = [
  {
    id: 1,
    image: img1,
    description: "Uno de los Estudios Jurídicos más destacados de Argentina, con partners en Uruguay, Colombia, México y EE. UU. Especialistas en Derecho Internacional, Civil, Comercial y Penal, su equipo altamente capacitado ofrece soluciones jurídicas de calidad, garantizando los más altos estándares profesionales ante cualquier eventualidad.",
  },
  {
    id: 2,
    image: img2,
    description: "Desde su sede en Dubái, ofrece servicios como Corporate Service Provider (CSP), asesorando en apertura de compañías, residencias y estructuras off-shore. Líder en Emiratos Árabes Unidos, es el referente para clientes de Latinoamérica y países hispanohablantes en soluciones comerciales internacionales.",
  },
  {
    id: 3,
    image: img3,
    description: "Empresa de Real Estate en Emiratos Árabes Unidos que ofrece asesoramiento personalizado en inversiones inmobiliarias estratégicas. Con un equipo proactivo, conecta a los inversores con las oportunidades únicas de un mercado en constante crecimiento y de gran proyección global.",
  },
  {
    id: 4,
    image: img4,
    description: "Con sede en EE. UU., brinda soluciones societarias internacionales ajustadas a los objetivos y metas comerciales de cada cliente. Especialistas en eficiencia fiscal, compliance y derecho internacional, su equipo altamente capacitado ofrece asesoría adaptada a cada jurisdicción.",
  },
  {
    id: 5,
    image: img5,
    description: "Expertos en compliance legal y tributario, garantizamos estrategias integrales para el cumplimiento normativo. Con un enfoque preventivo, ofrecemos asesoría personalizada, estructuras jurídicas y planificación patrimonial para eliminar riesgos fiscales y simplificar procesos empresariales.",
  },
  {
    id: 6,
    image: img6,
    description: "Poplavsky Legal Consultant FZE, parte de Poplavsky Group, brinda asesoramiento legal en Emiratos Árabes Unidos. Con más de 25 años de experiencia en Derecho Internacional, ofrece soluciones para empresas, inversores y particulares. Especializados en creación de empresas y cumplimiento normativo, garantizan éxito con ética, confidencialidad y un enfoque global.",
  },
];

const ServicesCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const [showModal, setShowModal] = useState(null);

  const handleOpenModal = (id) => {
    setShowModal(id);
  };

  const handleCloseModal = () => {
    setShowModal(null);
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0",
    afterChange: (current) => setActiveIndex(current),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          centerMode: false,
        },
      },
    ],
  };

  return (
    <div>
      <OptimizedSlider {...settings} className="services-carousel">
        {items.map((item, index) => (
          <div key={item.id} className={`services-item ${index === activeIndex ? "active" : "inactive"}`}>
            <img src={item.image} alt={item.title} className="services-image" />
            <p className="services-description">{item.description}</p>
            <button className="services-button" onClick={() => handleOpenModal(item.id)} >CONOCÉ SUS SERVICIOS</button>
          </div>
        ))}
      </OptimizedSlider>
      {showModal === 1 && (
          <Modal1 open={showModal} onClose={handleCloseModal} />
      )}
        {showModal === 2 && (
          <Modal2 open={showModal} onClose={handleCloseModal} />
      )}
      {showModal === 3 && (
          <Modal3 open={showModal} onClose={handleCloseModal} />
      )}
      {showModal === 4 && (
          <Modal4 open={showModal} onClose={handleCloseModal} />
      )}
      {showModal === 5 && (
          <Modal5 open={showModal} onClose={handleCloseModal} />
      )}
      {showModal === 6 && (
          <Modal6 open={showModal} onClose={handleCloseModal} />
      )}
    </div>
  );
};

export default ServicesCarousel;